var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M2 17C2.55228 17 3 17.4477 3 18V21H6C6.55228 21 7 21.4477 7 22C7 22.5523 6.55228 23 6 23H2C1.44772 23 1 22.5523 1 22V18C1 17.4477 1.44772 17 2 17Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M17 2C17 1.44772 17.4477 1 18 1H22C22.5523 1 23 1.44772 23 2V6C23 6.55228 22.5523 7 22 7C21.4477 7 21 6.55228 21 6V3H18C17.4477 3 17 2.55228 17 2Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M1 2C1 1.44772 1.44772 1 2 1H6C6.55228 1 7 1.44772 7 2C7 2.55228 6.55228 3 6 3H3V6C3 6.55228 2.55228 7 2 7C1.44772 7 1 6.55228 1 6V2Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M22 17C22.5523 17 23 17.4477 23 18V22C23 22.5523 22.5523 23 22 23H18C17.4477 23 17 22.5523 17 22C17 21.4477 17.4477 21 18 21H21V18C21 17.4477 21.4477 17 22 17Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M10 11C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5H6C5.44772 5 5 5.44772 5 6V10C5 10.5523 5.44772 11 6 11H10Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M18 11C18.5523 11 19 10.5523 19 10V6C19 5.44772 18.5523 5 18 5H14C13.4477 5 13 5.44772 13 6V10C13 10.5523 13.4477 11 14 11H18Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M10 19C10.5523 19 11 18.5523 11 18V14C11 13.4477 10.5523 13 10 13H6C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19H10Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M18 19C18.5523 19 19 18.5523 19 18V14C19 13.4477 18.5523 13 18 13H14C13.4477 13 13 13.4477 13 14V18C13 18.5523 13.4477 19 14 19H18Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M1 14C1 13.4477 1.44772 13 2 13H22C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H2C1.44772 15 1 14.5523 1 14Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQr);
export default __webpack_public_path__ + "static/media/scanQr.840b0a6e9a93fc45db79773be99a508f.svg";
export { ForwardRef as ReactComponent };